module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/viterbo.9ea8cb7db26ccea93a5def12d37df8ae.jpg";